import React, { useState, useEffect } from 'react';
import {
  Pane,
  Heading,
  Button,
  TextInputField,
  Table,
  Select,
  SideSheet,
  IconButton,
    Dialog,Checkbox,Tab,Menu,Text,toaster,
  Spinner, TextInput,TextareaField, Textarea, FilePicker, SelectMenu,Card,Tablist,Popover
} from 'evergreen-ui';
import { firestore } from '../appservices/firebase';
import { collection,setDoc, addDoc, getDocs,updateDoc, deleteDoc, doc,writeBatch } from 'firebase/firestore';

import AddCustomerForm, {AddPersonnelForm, AddProductForm} from './Forms';
import useStore from '../appservices/store';
// Constants for Roles
const ROLES = ["Owner", "IT Admin", "IT Support", "Basic"];

// AddProductForm.jsx

 
// Cloud Function endpoint
const ACCOUNT_MANAGER_ENDPOINT = 'https://us-east1-milli-8fba8.cloudfunctions.net/aiit/acct/account';
 
// const AddProductForm = ({
//   onClose,
//   fetchProducts,
//   productToEdit
// }) => {
//   // Determine if we're editing or creating a product
//   const isEditing = !!productToEdit;

//   // Retrieve businessProfile from Zustand store
//   const businessProfile = useStore((state) => state.businessProfile);
//   const storeBusinessId = businessProfile?.businessId || '';

//   // Initialize form data
//   const [formData, setFormData] = useState(() => ({
//     businessId: productToEdit?.businessId || storeBusinessId,
//     productId: productToEdit?.productId || '', // Relevant if editing
//     name: productToEdit?.name || '',
//     description: productToEdit?.description || '',
//     category: productToEdit?.category || '',
//     brand: productToEdit?.brand || '',
//     modelNumber: productToEdit?.modelNumber || '',
//     specifications: productToEdit?.specifications || '',
//     features: productToEdit?.features || '',
//     firmwareVersion: productToEdit?.firmwareVersion || '',
//     price: productToEdit?.price || '',
//     stockStatus: productToEdit?.stockStatus || '',
//     warrantyInfo: productToEdit?.warrantyInfo || '',
//     supportContact: productToEdit?.supportContact || ''
//   }));

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Update form data if productToEdit or businessProfile changes
//   useEffect(() => {
//     if (productToEdit) {
//       setFormData((prev) => ({
//         ...prev,
//         businessId: productToEdit.businessId || storeBusinessId,
//         productId: productToEdit.productId || '',
//         name: productToEdit.name || '',
//         description: productToEdit.description || '',
//         category: productToEdit.category || '',
//         brand: productToEdit.brand || '',
//         modelNumber: productToEdit.modelNumber || '',
//         specifications: productToEdit.specifications || '',
//         features: productToEdit.features || '',
//         firmwareVersion: productToEdit.firmwareVersion || '',
//         price: productToEdit.price || '',
//         stockStatus: productToEdit.stockStatus || '',
//         warrantyInfo: productToEdit.warrantyInfo || '',
//         supportContact: productToEdit.supportContact || ''
//       }));
//     } else {
//       // If not editing, ensure businessId is from the store
//       setFormData((prev) => ({
//         ...prev,
//         businessId: storeBusinessId
//       }));
//     }
//   }, [productToEdit, storeBusinessId]);

//   // Handle input changes
//   const handleInputChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   // Handle form submission
//   const handleSubmit = async () => {
//     // Basic required fields check
//     const requiredFields = ['name', 'category', 'brand', 'businessId'];
//     const missing = requiredFields.filter(f => !formData[f]);
//     if (missing.length > 0) {
//       toaster.warning(`Please fill out all required fields: ${missing.join(', ')}`);
//       return;
//     }

//     const operation = isEditing ? 'update' : 'create';
//     setIsSubmitting(true);

//     // Initialize Firestore batch
//     const batch = writeBatch(firestore);

//     try {
//       let productDocId = formData.productId;

//       if (isEditing) {
//         if (!productDocId) {
//           toaster.danger('Missing productId for editing mode.');
//           setIsSubmitting(false);
//           return;
//         }
//         // Reference to the existing product document
//         const productDocRef = doc(firestore, 'Products', productDocId);
//         // Update product details in /Products
//         batch.update(productDocRef, {
//           businessId: formData.businessId,
//           name: formData.name,
//           description: formData.description,
//           category: formData.category,
//           brand: formData.brand,
//           modelNumber: formData.modelNumber,
//           specifications: formData.specifications,
//           features: formData.features,
//           firmwareVersion: formData.firmwareVersion,
//           price: formData.price,
//           stockStatus: formData.stockStatus,
//           warrantyInfo: formData.warrantyInfo,
//           supportContact: formData.supportContact,
//           updatedAt: new Date().toISOString()
//         });
//       } else {
//         // Create a new product document in /Products
//         const productRef = doc(collection(firestore, 'Products')); // Generate a new doc with auto ID
//         productDocId = productRef.id; // Get the new product ID

//         // Set product details in /Products
//         batch.set(productRef, {
//           businessId: formData.businessId,
//           name: formData.name,
//           description: formData.description,
//           category: formData.category,
//           brand: formData.brand,
//           modelNumber: formData.modelNumber,
//           specifications: formData.specifications,
//           features: formData.features,
//           firmwareVersion: formData.firmwareVersion,
//           price: formData.price,
//           stockStatus: formData.stockStatus,
//           warrantyInfo: formData.warrantyInfo,
//           supportContact: formData.supportContact,
//           createdAt: new Date().toISOString(),
//           updatedAt: new Date().toISOString()
//         });
//       }

//       // Prepare key product information for /BusinessId/productdict
//       const businessProductDictRef = doc(firestore, `Businesses/${formData.businessId}/productdict`, productDocId);
//       const keyProductInfo = {
//         name: formData.name,
//         category: formData.category,
//         brand: formData.brand,
//         modelNumber: formData.modelNumber,
//         price: formData.price,
//         stockStatus: formData.stockStatus,
//         updatedAt: new Date().toISOString()
//       };

//       if (isEditing) {
//         // Update existing key product info
//         batch.update(businessProductDictRef, keyProductInfo);
//       } else {
//         // Add new key product info
//         batch.set(businessProductDictRef, keyProductInfo);
//       }

//       // // Prepare product reference for /Products/product_docs_dict
//       // const businessProductDictRef = doc(firestore, `Businesses/${formData.businessId}/productdict`, productDocId);

//       // const productDocsDictRef = doc(firestore, `Products/product_docs_dict`, productDocId);
//       // const productReference = {
//       //   productId: productDocId,
//       //   name: formData.name,
//       //   category: formData.category,
//       //   brand: formData.brand,
//       //   price: formData.price,
//       //   stockStatus: formData.stockStatus,
//       //   updatedAt: new Date().toISOString()
//       // };

//       // if (isEditing) {
//       //   // Update existing product reference
//       //   batch.update(productDocsDictRef, productReference);
//       // } else {
//       //   // Add new product reference
//       //   batch.set(productDocsDictRef, productReference);
//       // }

//       // // Commit the batch
//       // await batch.commit();

//       // Prepare payload for the backend Cloud Function
//       const payload = {
//         entity: 'product',
//         operation,
//         data: {
//           businessId: formData.businessId,
//           productId: productDocId, // The Firestore doc ID
//           name: formData.name,
//           description: formData.description,
//           category: formData.category,
//           brand: formData.brand,
//           modelNumber: formData.modelNumber,
//           specifications: formData.specifications,
//           features: formData.features,
//           firmwareVersion: formData.firmwareVersion,
//           price: formData.price,
//           stockStatus: formData.stockStatus,
//           warrantyInfo: formData.warrantyInfo,
//           supportContact: formData.supportContact
//         }
//       };

//       // Call the backend Cloud Function
//       const response = await fetch(ACCOUNT_MANAGER_ENDPOINT, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         console.error('Server returned:', response.status);
//         throw new Error(`Server returned ${response.status}`);
//       }

//       const result = await response.json();
//       if (result.error) {
//         toaster.danger(result.error);
//       } else {
//         toaster.success(result.message || 'Product saved successfully!');
//         // Refresh product list if needed
//         if (fetchProducts) fetchProducts();
//         // Close the SideSheet
//         onClose();
//       }
//     } catch (error) {
//       console.error('Error managing product:', error);
//       toaster.danger('Failed to save product. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <Pane padding={16} width="100%">
//       <Heading size={600} marginBottom={16}>
//         {isEditing ? 'Edit Product' : 'Add New Product'}
//       </Heading>

//       <Pane display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={16}>
//         <TextInputField
//           label="Product Name"
//           value={formData.name}
//           onChange={(e) => handleInputChange('name', e.target.value)}
//           placeholder="Enter product name"
//           required
//         />
//         <TextInputField
//           label="Category"
//           value={formData.category}
//           onChange={(e) => handleInputChange('category', e.target.value)}
//           placeholder="e.g., Smartphone, Laptop"
//           required
//         />
//         <TextInputField
//           label="Brand/Manufacturer"
//           value={formData.brand}
//           onChange={(e) => handleInputChange('brand', e.target.value)}
//           placeholder="e.g., Apple, Samsung"
//           required
//         />
//         <TextInputField
//           label="Model Number"
//           value={formData.modelNumber}
//           onChange={(e) => handleInputChange('modelNumber', e.target.value)}
//           placeholder="e.g., SM-T510"
//         />

//         <TextareaField
//           label="Specifications"
//           value={formData.specifications}
//           onChange={(e) => handleInputChange('specifications', e.target.value)}
//           placeholder="List technical details"
//         />
//         <TextareaField
//           label="Features"
//           value={formData.features}
//           onChange={(e) => handleInputChange('features', e.target.value)}
//           placeholder="Highlight key features"
//         />

//         <TextInputField
//           label="Firmware/Software Version"
//           value={formData.firmwareVersion}
//           onChange={(e) => handleInputChange('firmwareVersion', e.target.value)}
//           placeholder="e.g., v1.2.3"
//         />
//         <TextInputField
//           label="Price (USD)"
//           value={formData.price}
//           onChange={(e) => handleInputChange('price', e.target.value)}
//           placeholder="Enter price"
//           type="number"
//         />

//         <SelectMenu
//           title="Stock Status"
//           options={[
//             { label: 'In Stock', value: 'In Stock' },
//             { label: 'Out of Stock', value: 'Out of Stock' },
//             { label: 'Pre-Order', value: 'Pre-Order' },
//           ]}
//           selected={formData.stockStatus}
//           onSelect={(item) => handleInputChange('stockStatus', item.value)}
//         >
//           <Button>{formData.stockStatus || 'Select Stock Status'}</Button>
//         </SelectMenu>

//         <TextInputField
//           label="Warranty Information"
//           value={formData.warrantyInfo}
//           onChange={(e) => handleInputChange('warrantyInfo', e.target.value)}
//           placeholder="e.g., 1 year limited warranty"
//         />
//         <TextInputField
//           label="Support Contact Information"
//           value={formData.supportContact}
//           onChange={(e) => handleInputChange('supportContact', e.target.value)}
//           placeholder="e.g., support@company.com"
//         />

//         <FilePicker
//           multiple
//           width="100%"
//           onChange={(files) => console.log('Files chosen:', files)}
//           placeholder="Upload product images (optional)"
//         />
//       </Pane>

//       <Pane marginTop={16} display="flex" justifyContent="flex-end">
//         <Button
//           appearance="primary"
//           isLoading={isSubmitting}
//           disabled={isSubmitting}
//           onClick={handleSubmit}
//         >
//           {isEditing ? 'Update Product' : 'Save Product'}
//         </Button>
//       </Pane>
//     </Pane>
//   );
// };

 

 



const ProductDetailView = ({ product, onEdit }) => {
  if (!product) return null

  // Example fields for display (adjust to your schema)
  const {
    name,
    category,
    brand,
    modelNumber,
    price,
    stockStatus,
    warrantyInfo,
    supportContact,
    documents = [],
    attributes = []
  } = product

  return (
    <Pane>
      <Heading size={600} marginBottom={16}>
        {name}
      </Heading>

      <Pane marginBottom={16}>
        <Text size={400} fontWeight="bold">
          Category:
        </Text>{' '}
        <Text>{category || 'N/A'}</Text>
      </Pane>

      <Pane marginBottom={16}>
        <Text size={400} fontWeight="bold">
          Brand:
        </Text>{' '}
        <Text>{brand || 'N/A'}</Text>
      </Pane>

      {modelNumber && (
        <Pane marginBottom={16}>
          <Text size={400} fontWeight="bold">
            Model Number:
          </Text>{' '}
          <Text>{modelNumber}</Text>
        </Pane>
      )}

      {price && (
        <Pane marginBottom={16}>
          <Text size={400} fontWeight="bold">
            Price:
          </Text>{' '}
          <Text color="green">${price}</Text>
        </Pane>
      )}

      {stockStatus && (
        <Pane marginBottom={16}>
          <Text size={400} fontWeight="bold">
            Stock Status:
          </Text>{' '}
          <Text>{stockStatus}</Text>
        </Pane>
      )}

      {warrantyInfo && (
        <Pane marginBottom={16}>
          <Text size={400} fontWeight="bold">
            Warranty:
          </Text>{' '}
          <Text>{warrantyInfo}</Text>
        </Pane>
      )}

      {supportContact && (
        <Pane marginBottom={16}>
          <Text size={400} fontWeight="bold">
            Support Contact:
          </Text>{' '}
          <Text>{supportContact}</Text>
        </Pane>
      )}

      {/* Render Documents, if any */}
      {documents.length > 0 && (
        <Pane marginBottom={16}>
          <Heading size={400} marginBottom={8}>
            Documents
          </Heading>
          {documents.map((doc) => (
            <Pane key={doc.id} display="flex" alignItems="center" marginBottom={4}>
              <Text marginRight={8}>{doc.name}</Text>
              <Button
                appearance="minimal"
                intent="success"
                onClick={() => window.open(doc.url, '_blank')}
              >
                View
              </Button>
            </Pane>
          ))}
        </Pane>
      )}

      {/* Render Attributes, if any */}
      {attributes.length > 0 && (
        <Pane marginBottom={16}>
          <Heading size={400} marginBottom={8}>
            Additional Attributes
          </Heading>
          {attributes.map((attr, idx) => (
            <Pane key={idx} display="flex" marginBottom={4}>
              <Text fontWeight="bold" marginRight={8}>
                {attr.name}:
              </Text>
              <Text>{attr.value}</Text>
            </Pane>
          ))}
        </Pane>
      )}

      {/* Edit Button */}
      <Pane display="flex" justifyContent="flex-end" marginTop={24}>
        <Button appearance="primary" onClick={onEdit}>
          Edit Product
        </Button>
      </Pane>
    </Pane>
  )
}


 
const Overview = () => {
  // Tabs + State
  const [selectedTab, setSelectedTab] = useState('products')
  const [isSideSheetOpen, setIsSideSheetOpen] = useState(false)
  const [sideSheetType, setSideSheetType] = useState('') // 'product' | 'person' | 'customer'
  const [selectedEntity, setSelectedEntity] = useState(null)

  // Data
  const [products, setProducts] = useState([])
  const [people, setPeople] = useState([])
  const [customers, setCustomers] = useState([])

  // Loading states for each collection
  const [loading, setLoading] = useState({
    products: false,
    people: false,
    customers: false
  })

  // Delete dialog
  const [isDeleteDialogShown, setIsDeleteDialogShown] = useState(false)
  const [entityToDelete, setEntityToDelete] = useState(null)

  // "viewMode" => 'details' for read-only product details, 'edit' for edit form
  const [viewMode, setViewMode] = useState('details')

  // ===== FETCHERS =====
  const fetchProducts = async () => {
    setLoading((prev) => ({ ...prev, products: true }))
    try {
      const querySnapshot = await getDocs(collection(firestore, 'Products'))
      const productList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
      setProducts(productList)
    } catch (error) {
      console.error('Error fetching products:', error)
      toaster.danger('Failed to load products.')
    } finally {
      setLoading((prev) => ({ ...prev, products: false }))
    }
  }

  const fetchPeople = async () => {
    setLoading((prev) => ({ ...prev, people: true }))
    try {
      const querySnapshot = await getDocs(collection(firestore, 'People'))
      const peopleList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
      setPeople(peopleList)
    } catch (error) {
      console.error('Error fetching people:', error)
      toaster.danger('Failed to load people.')
    } finally {
      setLoading((prev) => ({ ...prev, people: false }))
    }
  }

  const fetchCustomers = async () => {
    setLoading((prev) => ({ ...prev, customers: true }))
    try {
      const querySnapshot = await getDocs(collection(firestore, 'Customers'))
      const customerList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
      setCustomers(customerList)
    } catch (error) {
      console.error('Error fetching customers:', error)
      toaster.danger('Failed to load customers.')
    } finally {
      setLoading((prev) => ({ ...prev, customers: false }))
    }
  }

  // ===== useEffect to load data on mount =====
  useEffect(() => {
    fetchProducts()
    fetchPeople()
    fetchCustomers()
  }, [])

  // ===== DELETE ENTITY =====
  const handleDeleteEntity = async () => {
    try {
      if (entityToDelete) {
        // Determine which collection to delete from
        const collectionName =
          sideSheetType === 'product'
            ? 'Products'
            : sideSheetType === 'person'
            ? 'People'
            : 'Customers'

        await deleteDoc(doc(firestore, collectionName, entityToDelete.id))
        toaster.success(`${capitalizeFirstLetter(sideSheetType)} deleted successfully`)

        // Refresh the relevant data
        if (sideSheetType === 'product') await fetchProducts()
        if (sideSheetType === 'person') await fetchPeople()
        if (sideSheetType === 'customer') await fetchCustomers()
      }
    } catch (error) {
      console.error('Error deleting entity:', error)
      toaster.danger('Failed to delete entity. Please try again.')
    } finally {
      setEntityToDelete(null)
      setIsDeleteDialogShown(false)
    }
  }

  // ===== UTILITY =====
  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1)

  // ===== RENDER FUNCTIONS =====
  // Show products in a card-based layout
  const renderProductView = () => {
    return (
      <Pane display="flex" flexWrap="wrap" justifyContent="flex-start" gap={24} padding={16}>
        {products.map((product) => (
          <Pane
            key={product.id}
            elevation={2}
            background="tint1"
            borderRadius={8}
            width={240}
            padding={16}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
            cursor="pointer"
            transition="transform 0.2s, box-shadow 0.2s"
            hoverElevation={3}
            onClick={() => {
              setSelectedEntity(product)
              setSideSheetType('product')
              setViewMode('details') // Show the product in read-only detail mode
              setIsSideSheetOpen(true)
            }}
          >
            {/* Product Name */}
            <Text size={500} fontWeight={600} marginBottom={8} textAlign="center">
              {product.name}
            </Text>
            {/* Category */}
            <Text size={400} color="muted" marginBottom={8} textAlign="center">
              {product.category}
            </Text>
            {/* Optional price display */}
            {product.price && (
              <Text size={400} color="green" fontWeight={500}>
                ${product.price}
              </Text>
            )}
          </Pane>
        ))}
      </Pane>
    )
  }

  // Show a generic grid for People or Customers
  const renderGrid = (data, type) => {
    return (
      <Pane display="grid" gridTemplateColumns="repeat(auto-fill, minmax(250px, 1fr))" gap={16} marginTop={16}>
        {data.map((item) => (
          <Pane
            key={item.id}
            elevation={1}
            padding={16}
            display="flex"
            flexDirection="column"
            background="tint2"
            onClick={() => {
              setSelectedEntity(item)
              setSideSheetType(type)
              setIsSideSheetOpen(true)
            }}
          >
            <Text size={500} fontWeight="bold" marginBottom={8}>
              {type === 'person' ? `${item.firstName} ${item.lastName}` : item.name ?? 'N/A'}
            </Text>
            <Text size={400} marginBottom={8}>
              {type === 'person' ? item.email : item.category ?? ''}
            </Text>
          </Pane>
        ))}
      </Pane>
    )
  }

  // ===== MAIN RENDER =====
  return (
    <Pane padding={16}>
      <Heading size={700} marginBottom={16}>
        Overview
      </Heading>

      {/* Tabs + Add Menu */}
      <Pane marginBottom={16} display="flex" justifyContent="space-between" alignItems="center">
        {/* Tablist */}
        <Tablist>
          {['products', 'people', 'customers'].map((tab) => (
            <Tab
              key={tab}
              id={tab}
              isSelected={selectedTab === tab}
              onSelect={() => setSelectedTab(tab)}
              aria-controls={`panel-${tab}`}
            >
              {capitalizeFirstLetter(tab)}
            </Tab>
          ))}
        </Tablist>

        {/* Add Menu */}
        <Popover
          content={
            <Menu>
              <Menu.Group title="Add New">
                {/* Add Product */}
                <Menu.Item
                  onClick={() => {
                    setSideSheetType('product')
                    setSelectedEntity(null) // Start fresh
                    setViewMode('edit') // Go directly to edit (create) form
                    setIsSideSheetOpen(true)
                  }}
                >
                  Product
                </Menu.Item>
                {/* Add Person */}
                <Menu.Item
                  onClick={() => {
                    setSideSheetType('person')
                    setSelectedEntity(null)
                    setIsSideSheetOpen(true)
                  }}
                >
                  Personnel
                </Menu.Item>
                {/* Add Customer */}
                <Menu.Item
                  onClick={() => {
                    setSideSheetType('customer')
                    setSelectedEntity(null)
                    setIsSideSheetOpen(true)
                  }}
                >
                  Customer
                </Menu.Item>
              </Menu.Group>
            </Menu>
          }
        >
          <Button iconBefore="plus" appearance="primary">
            Add
          </Button>
        </Popover>
      </Pane>

      {/* Tab Content */}
      <Pane id={`panel-${selectedTab}`} role="tabpanel">
        {loading[selectedTab] ? (
          <Spinner />
        ) : selectedTab === 'products' ? (
          renderProductView()
        ) : selectedTab === 'people' ? (
          renderGrid(people, 'person')
        ) : (
          renderGrid(customers, 'customer')
        )}
      </Pane>

      {/* SideSheet for Add/Edit or Detail */}
      <SideSheet
        isShown={isSideSheetOpen}
        onCloseComplete={() => {
          setIsSideSheetOpen(false)
          setViewMode('details') // reset for next time
        }}
        title={
          sideSheetType === 'product'
            ? selectedEntity
              ? 'Product Details'
              : 'Add Product'
            : sideSheetType === 'person'
            ? selectedEntity
              ? 'Edit Personnel'
              : 'Add Personnel'
            : selectedEntity
            ? 'Edit Customer'
            : 'Add Customer'
        }
      >
        <Pane padding={16}>
          {/* PRODUCT SECTION */}
          {sideSheetType === 'product' && (
            <>
              {selectedEntity && viewMode === 'details' && (
                <ProductDetailView
                  product={selectedEntity}
                  onEdit={() => setViewMode('edit')}
                />
              )}
              {(!selectedEntity && viewMode === 'edit') ||
                (selectedEntity && viewMode === 'edit') ? (
                  <AddProductForm
                    onClose={() => setIsSideSheetOpen(false)}
                    fetchProducts={fetchProducts}
                    productToEdit={selectedEntity}
                  />
                ) : null}
            </>
          )}

          {/* PERSONNEL SECTION */}
          {sideSheetType === 'person' && (
            <AddPersonnelForm
              onClose={() => setIsSideSheetOpen(false)}
              fetchPeople={fetchPeople}
              personToEdit={selectedEntity}
            />
          )}

          {/* CUSTOMER SECTION */}
          {sideSheetType === 'customer' && (
            <AddCustomerForm
              onClose={() => setIsSideSheetOpen(false)}
              fetchCustomers={fetchCustomers}
              customerToEdit={selectedEntity}
            />
          )}
        </Pane>
      </SideSheet>

      {/* Delete Confirmation Dialog */}
      <Dialog
        isShown={isDeleteDialogShown}
        title={`Delete ${sideSheetType}`}
        intent="danger"
        onCloseComplete={() => setIsDeleteDialogShown(false)}
        onConfirm={handleDeleteEntity}
        confirmLabel="Delete"
      >
        Are you sure you want to delete this {sideSheetType}? This action cannot be undone.
      </Dialog>
    </Pane>
  )
}

export default Overview
